import axios from 'axios';

export function getRoles() {
  return async (dispatch) => {
    dispatch(rolesInit());
    try {
      const response = await axios.get('/roles');
      const data = await response.data;
      dispatch(rolesSuccess(data));
    } catch (error) {
      dispatch(rolesError(error));
    }
  };
}

const rolesInit = () => ({ type: 'ROLES_INIT' });
const rolesError = (error) => ({ type: 'ROLES_ERROR', payload: error });
const rolesSuccess = (data) => ({ type: 'ROLES_SUCESS', payload: data });

const initialState = {
  name: 'roles',
  state: false,
  loading: true,
  roles: [],
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'ROLES_INIT':
      return {
        state: false,
        loading: true,
      };
    case 'ROLES_SUCESS':
      return {
        state: false,
        loading: true,
        roles: action.payload,
      };
    case 'ROLES_ERROR':
      return {
        state: false,
        loading: true,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
